import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"transitionLineItemState"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`lineItemId`}</inlineCode>{` - String`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`quantity`}</inlineCode>{` - Number`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`fromState`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#reference"
          }}>{`Reference`}</a>{` to a `}<a parentName="li" {...{
            "href": "/api/../api/projects/states#state"
          }}>{`State`}</a></li>
        <li parentName="ul"><inlineCode parentName="li">{`toState`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#reference"
          }}>{`Reference`}</a>{` to a `}<a parentName="li" {...{
            "href": "/api/../api/projects/states#state"
          }}>{`State`}</a></li>
        <li parentName="ul"><inlineCode parentName="li">{`actualTransitionDate`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#datetime"
          }}>{`DateTime`}</a>{` - Optional`}</li>
      </ul>
      <p parentName="section">{`This update action produces a `}<a parentName="p" {...{
          "href": "/api/../api/projects/messages#line-item-state-transition"
        }}>{`LineItemStateTransition`}</a>{` Message.`}</p>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      